<!-- Menu Administrativo Principal -->
<div *ngIf="selectedMenu === ''" class="flex flex-col w-full h-full bg-gray-100 p-4">
  <div class="bg-white rounded-lg shadow-md p-6">
    <h2 class="text-2xl font-bold text-gray-800 mb-6">Menu Administrativo</h2>
    
    <div class="grid grid-cols-2 gap-4">
      <!-- Abrir Turno - só aparece se NÃO houver turno aberto -->
      <button 
        *ngIf="!hasOpenShift"
        (click)="openShiftWork()"
        class="p-4 bg-orange-600 text-white rounded-lg hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 transition-colors cursor-pointer">
        <div class="text-center">
          <div class="text-lg font-semibold">F1</div>
          <div class="text-sm">Abrir Turno</div>
        </div>
      </button>
      
      <!-- Fechar Turno - só aparece se HOUVER turno aberto -->
      <button 
        *ngIf="hasOpenShift"
        (click)="closeShiftWork()"
        class="p-4 bg-orange-600 text-white rounded-lg hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 transition-colors cursor-pointer">
        <div class="text-center">
          <div class="text-lg font-semibold">F2</div>
          <div class="text-sm">Fechar Turno</div>
        </div>
      </button>
      
      <!-- <button 
        (click)="openSales()"
        class="p-4 bg-orange-600 text-white rounded-lg hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 transition-colors cursor-pointer">
        <div class="text-center">
          <div class="text-lg font-semibold">F3</div>
          <div class="text-sm">Vendas</div>
        </div>
      </button> -->
      
      
      <button 
        (click)="openRecords()"
        class="p-4 bg-orange-600 text-white rounded-lg hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 transition-colors cursor-pointer">
        <div class="text-center">
          <div class="text-lg font-semibold">F4</div>
          <div class="text-sm">Retiradas e Suprimentos</div>
        </div>
      </button>
      
      <!-- <button 
        (click)="openClosures()"
        class="p-4 bg-orange-600 text-white rounded-lg hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 transition-colors cursor-pointer">
        <div class="text-center">
          <div class="text-lg font-semibold">F5</div>
          <div class="text-sm">Fechamento Caixa</div>
        </div>
      </button> -->
      
      <!-- Realizar Sangria - só aparece se houver turno aberto -->
      <button 
        *ngIf="hasOpenShift"
        (click)="openWithdrawal()"
        class="p-4 bg-orange-600 text-white rounded-lg hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 transition-colors cursor-pointer">
        <div class="text-center">
          <div class="text-lg font-semibold">F6</div>
          <div class="text-sm">Realizar Sangria</div>
        </div>
      </button>

      <!-- Realizar Suprimento - só aparece se houver turno aberto -->
      <button 
        *ngIf="hasOpenShift"
        (click)="openSupply()"
        class="p-4 bg-orange-600 text-white rounded-lg hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 transition-colors cursor-pointer">
        <div class="text-center">
          <div class="text-lg font-semibold">F9</div>
          <div class="text-sm">Realizar Suprimento</div>
        </div>
      </button>
      
      <!-- <button 
        (click)="openReceipts()"
        class="p-4 bg-orange-600 text-white rounded-lg hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 transition-colors cursor-pointer">
        <div class="text-center">
          <div class="text-lg font-semibold">F7</div>
          <div class="text-sm">Recebimentos</div>
        </div>
      </button> -->
      
      <!-- <button 
        (click)="openExchanges()"
        class="p-4 bg-orange-600 text-white rounded-lg hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 transition-colors cursor-pointer">
        <div class="text-center">
          <div class="text-lg font-semibold">F8</div>
          <div class="text-sm">Trocas</div>
        </div>
      </button> -->
      
      <button 
        (click)="goBack()"
        class="p-4 bg-gray-600 text-white rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors cursor-pointer">
        <div class="text-center">
          <div class="text-lg font-semibold">ESC</div>
          <div class="text-sm">Voltar</div>
        </div>
      </button>
    </div>
  </div>
</div>

<!-- Abertura de Turno -->
<app-open-shift-work *ngIf="selectedMenu === 'OPEN_SHIFT'"></app-open-shift-work>

<!-- Fechamento de Turno -->
<app-close-shift-work *ngIf="selectedMenu === 'CLOSE_SHIFT'"></app-close-shift-work>

<!-- Crediário -->
<app-credito *ngIf="selectedMenu === 'CREDITO'"></app-credito>

<!-- Realização de Sangria -->
<app-withdrawal *ngIf="selectedMenu === 'WITHDRAWAL'"></app-withdrawal>

<!-- Consulta de Retiradas e Suprimentos -->
<app-withdrawal-list *ngIf="selectedMenu === 'WITHDRAWAL_LIST'"></app-withdrawal-list>

<!-- Realização de Suprimento -->
<app-supply *ngIf="selectedMenu === 'SUPPLY'"></app-supply>

<!-- Fechamento de Caixa -->
<app-cash-closure *ngIf="selectedMenu === 'CASH_CLOSURE'"></app-cash-closure>